__turbopack_context__.v({
  "borrowingGrid": "style-module-scss-module__gO1n0G__borrowingGrid",
  "calculatorGrid": "style-module-scss-module__gO1n0G__calculatorGrid",
  "column": "style-module-scss-module__gO1n0G__column",
  "footerCard": "style-module-scss-module__gO1n0G__footerCard",
  "inputCard": "style-module-scss-module__gO1n0G__inputCard",
  "inputCardTitle": "style-module-scss-module__gO1n0G__inputCardTitle",
  "main": "style-module-scss-module__gO1n0G__main",
  "page": "style-module-scss-module__gO1n0G__page",
  "pageHeader": "style-module-scss-module__gO1n0G__pageHeader",
  "saveShareContainer": "style-module-scss-module__gO1n0G__saveShareContainer",
  "tabContent": "style-module-scss-module__gO1n0G__tabContent",
  "tabHeader": "style-module-scss-module__gO1n0G__tabHeader",
  "tabsContainer": "style-module-scss-module__gO1n0G__tabsContainer",
});
